import styled from 'foundations-theming/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { requestSucceeded } from 'redux-request-state/util/requestStateCheckers';
import http from 'hub-http/clients/apiClient';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { getAutotranslationCreatedSuccessMessageHidden } from '../../redux/selectors/cmsSettingsSelectors';
import { useQueryParams } from '../../utils/routingUtils';
import { Modal } from 'foundations-components/transitional/components/Modal';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UILink from 'UIComponents/link/UILink';
import UIButton from 'UIComponents/button/UIButton';
import HR from 'UIComponents/elements/HR';
import UICheckbox from 'UIComponents/input/UICheckbox';
import I18n from 'I18n';
import { getContentModelName, getLanguage, getTranslatedFromId } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getContentPrimaryLanguage
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/selectors/translationSelectors';
import { getFetchCmsSettingsRequest } from 'ContentEditorUI/redux/selectors/requestStatesSelectors';
import { getIsBlogPost, getIsPage } from '../../redux/selectors/contentReadOnlyDataSelectors';
// @ts-expect-error Untyped module
import { openModal } from 'ContentEditorUI/redux/actions/appActions';
import { MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
import Raven from 'raven-js';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { DialogHeaderImage } from 'foundations-components/transitional/components/DialogHeaderImage';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContentPropertySubHeading = styled.span.withConfig({
  displayName: "TranslationCreatedSuccessMessage__ContentPropertySubHeading",
  componentId: "yi29cl-0"
})(["color:", ";"], ({
  theme
}) => theme.color['do-not-use-slinky']);
const TranslationCreatedSuccessMessage = () => {
  const {
    redirectFromMultiLangVariationCreation,
    isAutotranslated,
    redirectFromContentTranslated
  } = useQueryParams();
  const dispatch = useDispatch();
  const autotranslationCreatedSuccessMessageHidden = useSelector(getAutotranslationCreatedSuccessMessageHidden);
  const cmsSettingsRequestStatus = useSelector(getFetchCmsSettingsRequest);
  const contentName = useSelector(getContentModelName);
  const contentLanguage = useSelector(getLanguage);
  const translatedFromId = useSelector(getTranslatedFromId);
  const contentPrimaryLanguage = useSelector(getContentPrimaryLanguage);
  const isBlogPost = useSelector(getIsBlogPost);
  const isPage = useSelector(getIsPage);
  const shouldShowTranslationMessageForContent = !!translatedFromId && (isBlogPost || isPage);
  const contentNounKey = isBlogPost ? 'blog' : 'pages';
  const [autotranslationSuccessModalOpen, setAutotranslationSuccessModalOpen] = useState(false);
  const [createdTranslatedMlangVariationMessageShown, setCreatedTranslatedMlangVariationMessageShown] = useState(false);
  const [contentTranslatedMessageShown, setContentTranslatedMessageShown] = useState(false);
  const [doNotShowAgainChecked, setDoNotShowAgainChecked] = useState(false);
  const closeModal = () => setAutotranslationSuccessModalOpen(false);
  const handleDismissModal = useCallback(() => {
    if (doNotShowAgainChecked) {
      http.patch('cms-user-settings', {
        data: {
          autotranslationCreatedSuccessMessageHidden: true
        }
      }).catch(responseError => {
        Raven.captureException(new Error('Error in patching cms-user-settings for updating autotranslationCreatedSuccessMessageHidden'), {
          extra: {
            responseError
          }
        });
      });
    }
    closeModal();
  }, [doNotShowAgainChecked]);
  useEffect(() => {
    if (!contentTranslatedMessageShown && redirectFromContentTranslated === 'true') {
      FloatingAlertStore.addAlert({
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `contentTranslationSuccessfulMessage.alert.${contentNounKey}.title`
        }),
        message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: `contentTranslationSuccessfulMessage.alert.${contentNounKey}.message_jsx`,
          options: {
            onClick: () => dispatch(openModal(MODAL_TYPES.SETTINGS_MODAL))
          },
          elements: {
            UILink
          }
        }),
        style: {
          maxWidth: '90%'
        },
        type: 'success',
        timeout: 8000
      });
      setContentTranslatedMessageShown(true);
    }
  }, [redirectFromContentTranslated, contentTranslatedMessageShown, contentNounKey, dispatch]);
  useEffect(() => {
    if (!createdTranslatedMlangVariationMessageShown && shouldShowTranslationMessageForContent && redirectFromMultiLangVariationCreation === 'true') {
      if (requestSucceeded(cmsSettingsRequestStatus) && !autotranslationSuccessModalOpen && isAutotranslated === 'true') {
        if (!autotranslationCreatedSuccessMessageHidden) {
          setAutotranslationSuccessModalOpen(true);
          setCreatedTranslatedMlangVariationMessageShown(true);
        } else {
          FloatingAlertStore.addAlert({
            titleText: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `autotranslationCreatedSuccessMessage.alert.title.${contentNounKey}`
            }),
            message: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "autotranslationCreatedSuccessMessage.alert.message"
            }),
            style: {
              maxWidth: '90%'
            },
            type: 'success',
            timeout: 8000
          });
        }
      } else {
        FloatingAlertStore.addAlert({
          titleText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "translationCreatedSuccessMessage.alert.title"
          }),
          message: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "translationCreatedSuccessMessage.alert.message"
          }),
          style: {
            maxWidth: '90%'
          },
          type: 'success',
          timeout: 8000
        });
        setCreatedTranslatedMlangVariationMessageShown(true);
      }
    }
  }, [autotranslationCreatedSuccessMessageHidden, autotranslationSuccessModalOpen, contentNounKey, isAutotranslated, redirectFromMultiLangVariationCreation, shouldShowTranslationMessageForContent, createdTranslatedMlangVariationMessageShown, cmsSettingsRequestStatus]);
  if (shouldShowTranslationMessageForContent && autotranslationSuccessModalOpen) {
    return /*#__PURE__*/_jsxs(Modal, {
      paddingBlockStart: "1000",
      use: "success",
      width: "540px",
      children: [/*#__PURE__*/_jsx(DialogHeaderImage, {
        offsetBottom: -36,
        offsetTop: 84,
        children: /*#__PURE__*/_jsx(UIIllustration, {
          alt: I18n.text('autotranslationCreatedModal.illustrationAlt'),
          name: "automated-testing",
          width: 125
        })
      }), /*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: closeModal
        }), /*#__PURE__*/_jsx(Text, {
          as: "h2",
          textAlign: "center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "autotranslationCreatedModal.header"
          })
        })]
      }), /*#__PURE__*/_jsx(DialogBody, {
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `autotranslationCreatedModal.body.${contentNounKey}`,
              options: {
                language: I18n.text(`SharedI18nStrings.languageNames.${contentLanguage}`)
              }
            })
          }), /*#__PURE__*/_jsxs("p", {
            children: [/*#__PURE__*/_jsx(ContentPropertySubHeading, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `autotranslationCreatedModal.name.${contentNounKey}`
              })
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("span", {
              children: contentName
            })]
          }), /*#__PURE__*/_jsxs("p", {
            children: [/*#__PURE__*/_jsx(ContentPropertySubHeading, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "autotranslationCreatedModal.primaryLanguage"
              })
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
              message: `SharedI18nStrings.languageNames.${contentPrimaryLanguage}`
            })]
          }), /*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "autotranslationCreatedModal.switchVariationHelp"
            })
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(UICheckbox, {
              checked: doNotShowAgainChecked,
              onChange: ({
                target: {
                  checked
                }
              }) => {
                setDoNotShowAgainChecked(checked);
              },
              size: "sm",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "autotranslationCreatedModal.doNotShowMessageOption"
              })
            })
          })]
        })
      }), /*#__PURE__*/_jsx(DialogFooter, {
        children: /*#__PURE__*/_jsx(UIButton, {
          onClick: handleDismissModal,
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "autotranslationCreatedModal.dismiss"
          })
        })
      })]
    });
  }
  return null;
};
export default TranslationCreatedSuccessMessage;